import { render, staticRenderFns } from "./BarraSuperior.vue?vue&type=template&id=aee14050&"
import script from "./BarraSuperior.vue?vue&type=script&lang=js&"
export * from "./BarraSuperior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports